import { render, staticRenderFns } from "./RothConversionWizard.vue?vue&type=template&id=0ffbfeba&scoped=true&"
import script from "./RothConversionWizard.vue?vue&type=script&lang=js&"
export * from "./RothConversionWizard.vue?vue&type=script&lang=js&"
import style0 from "./RothConversionWizard.vue?vue&type=style&index=0&id=0ffbfeba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffbfeba",
  null
  
)

export default component.exports